import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../lib/api';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login?error=no_session');
        return;
      }

      try {
        // Exchange session_id for session_token
        const response = await fetch(`${API_URL}/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error('Failed to exchange session');
        }

        const userData = await response.json();
        setUser(userData);

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect based on user role
        if (!userData.role) {
          // New user, needs to select role
          navigate('/onboarding', { state: { user: userData } });
        } else if (userData.role === 'prestador') {
          navigate('/provider/dashboard', { state: { user: userData } });
        } else {
          navigate('/client/home', { state: { user: userData } });
        }
      } catch (error) {
        navigate('/login?error=auth_failed');
      }
    };

    processAuth();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-muted-foreground">A autenticar...</p>
      </div>
    </div>
  );
}
